import { render, staticRenderFns } from "./basic-button.vue?vue&type=template&id=c86999ee&scoped=true&lang=pug&"
import script from "./basic-button.ts?vue&type=script&lang=ts&"
export * from "./basic-button.ts?vue&type=script&lang=ts&"
import style0 from "./basic-button.vue?vue&type=style&index=0&id=c86999ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86999ee",
  null
  
)

export default component.exports